export const expert_landing_page_style = {
  rootSx: {
    height: '100vh',
    backgroundColor: '#402F9C',
    backgroundImage: ' linear-gradient(#7A65E8, #402F9C)',
    display: 'grid',
    alignItems: 'end',
  },
};
